import * as PIXI from 'pixi.js'
import { tools } from './config'

let toolsConfig = null
let toolsContainer = null
let toolsOptions = null
let pixiApp = null
function updateTools(funcName, event, vm) {
  if (!toolsContainer) return
  // TODO: 清除不使用的 container
  // 此处是隐藏所有的 container，然后需要展示的再展示，可按需优化
  toolsContainer.children.forEach(item => {
    item.visible = false
  })
  toolsConfig.forEach(config => {
    const tool = tools[config.name]
    if (tool) {
      let toolContainer = toolsContainer.getChildByName(config.name)
      if (!toolContainer) {
        toolContainer = new PIXI.Container()
        toolContainer.name = config.name
        toolsContainer.addChild(toolContainer)
      }
      toolContainer.visible = true
      tool[funcName](event, config, toolContainer, pixiApp, toolsOptions, vm)
    }
  })
}

export default {
  update(event, configs, container, app, options, vm) {
    toolsConfig = configs
    toolsContainer = container // tools container
    toolsOptions = options
    pixiApp = app
    updateTools('update', event, vm)
  },
  mouseDown(event) {
    updateTools('mouseDown', event)
  },
  mouseUp(event) {
    updateTools('mouseUp', event)
  },
  mouseWheel(event) {
    updateTools('mouseWheel', event)
  },
  mouseMove(event) {
    updateTools('mouseMove', event)
  },
  mouseLeave(event) {
    updateTools('mouseLeave', event)
  },
}
